/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import axios from 'axios';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setUserSignedUp } from '../../../../../actions/offer.actions';
import Button from '../../../../../shared/components/Button';
import OauthButton from '../../../../../shared/components/OauthButton/OauthButton';
import UserThumbnail from '../../../../../shared/components/UserThumbnail/UserThumbnail';

const LOCALES_PATH = 'influencers.pages.campaign.apply_side_pane.facebook_connect.';

const InstagramSuccess = ({
  onRequestClose,
  nextStep,
  termsAndLegalComplete,
  userOffer,
}) => {
  const { t } = useTranslation();
  const user = useSelector(store => get(store, 'auth.user'));
  const dispatch = useDispatch();
  const testFlow = useSelector(state => state.config.test);

  const handleFinish = () => {
    axios.patch(`/api/v1/influencers/user_offers/${userOffer.id}`, {
      user_offer: {
        // Placeholder to submit form
        user_offer_linked_talent_agents: []
      }
    })
      .then(({ data }) => {
        dispatch(setUserSignedUp(!!get(data, 'user_offer.participation_form_completed_at', false)));

        onRequestClose({ savedApplication: true });
      }).catch(err => {
        console.log(err);
      });
  };

  return <div>

    <h3 className='mb-4'>
      {t(`${LOCALES_PATH}connected_successfully`)}
    </h3>

    <Card className='p-3'>
      <Row>
        <Col className="col-auto">
          <UserThumbnail platform='instagram'
            initials={get(user, 'social.inst.nickname')} />
        </Col>
        <Col className="col-auto">
          <div className='text-underline'>
            {get(user, 'social.inst.nickname')}
          </div>
        </Col>
      </Row>
    </Card>


    <hr className='my-6' />
    <Row className='justify-content-end'>
      <Col className="col-auto">
        <ButtonGroup className="non-adaptable">
          <OauthButton
            variant="secondary"
            type="button"
            text={t(`${LOCALES_PATH}disconnect`)}
            disconnect
            platform="facebook"
          />
          {
            testFlow.includes('fb_success')
              ? <Button
                variant='primary'
                onClick={() => {
                  if (testFlow.includes('fb_required') || testFlow.includes('yt')) {
                    nextStep();
                  } else if (testFlow.includes('fb_optional')) {
                    handleFinish();
                  }
                }}>
                {t('influencers.common.next')}
              </Button>
              : <Button
                variant="primary"
                type="submit"
                onClick={!termsAndLegalComplete ? () => nextStep({ connectFacebook: true, }) : handleFinish}>
                {termsAndLegalComplete
                  ? t('influencers.common.finish')
                  : t('influencers.common.next')
                }
              </Button>
          }
        </ButtonGroup>
      </Col>
    </Row>
  </div>;
};

InstagramSuccess.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  termsAndLegalComplete: PropTypes.bool.isRequired,
};
export default InstagramSuccess;